import { authGuard } from '@/auth/authGuard';

const routes = [
  {
    path: '/',
    component: () => import('../layouts/MainLayout.vue'),
    beforeEnter: authGuard,
    children: [
      { name: 'index', path: '', component: () => import('../pages/Dashboard')},
      { name: 'profile', path: 'profile', component: () => import('../pages/Profile')},
      { name: 'projects', path: 'projects', component: () => import('../pages/Projects')},
    ]
  },
  // Always leave this as last one,
  // but you can also remove it
  {
    path: '*',
    component: () => import('../pages/Error404')
  }
]

export default routes
